import { useGetOnlineCourseDetail, useGetOnlineCourseSlot } from '../../assets/api/UseStudentGetApi'
import { useParams } from 'react-router-dom'
import { ImagePath, ImageRelativePath } from '../../shared/constants'
import { Box, Typography , Rating ,} from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { SkeletonCom, TextSkeleton } from '../../shared/utils/SkeletonCom'
import { useGetReviews } from '../../assets/nodeApi/getApi/getSchoolApi'
import ReviewRatingCom from './ReviewRatingComGet'
import StarIcon from '@mui/icons-material/Star';


export const TimeSlotChip = ({ label }) => {
    const iscontained = false;
    return (
        <Box

            sx={{
                background: iscontained ? "#4169E1" : 'primary.main',
                border: '1px solid #4169E1',
                padding: 0,
                mx: 1,
                borderRadius: '5px',
                minHeight: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 1,
                cursor: "pointer"
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: iscontained ? "primary.main" : '#4169E1',
                    textTransform: 'capitalize',
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export const SlotCard = ({ day, timing }) => {
    return (
        <Box sx={{ bgcolor: "#F4F4F4", display: "flex", justifyContent: "space-between", alignItems: "center", p: "1rem", borderRadius: "10px", my: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "start", gap: "0.5rem" }}>
                {day && <TimeSlotChip label={day} variant='outlined' />}
                <TimeSlotChip label={timing} variant='outlined' />
            </Box>

        </Box>
    )
}

export const SlotCard1 = ({ day, timing }) => {
    return (
        <Box sx={{ bgcolor: "#ECF5FF", display: "flex", justifyContent: "space-between", alignItems: "center", p: "1rem", borderRadius: "10px", my: 1, border: "1px solid #4E93E1" }}>
            <Typography>Day : {day}</Typography>
            <Typography> Timings : {timing}</Typography>

        </Box>
    )
}




const StudentOnlineCourseDetail = () => {
    const { slug, batch_id } = useParams()
    const { data: CourseSlot, isLoading: isSlotLoading } = useGetOnlineCourseSlot({ batch_id: batch_id })
    const { data: CourseDetail, isLoading } = useGetOnlineCourseDetail({ slug: slug })

    const { data: reviewsData, isLoading: isReviewsLoading } = useGetReviews({
        id: batch_id, // or slug if API uses slug
        page: 1,
        limit: 3,
    });



    return (
        <>
            {!isLoading && !isSlotLoading && <Box>
                <CustomDivider size={"1rem"} />
                <Typography variant='h2'>{CourseDetail?.data?.title}</Typography>
                <CustomDivider size={"1rem"} />
                <img src={`${ImagePath}${ImageRelativePath}${CourseDetail?.data?.cover_image}`} width="100%" alt="Online Course Cover Image" style={{ borderRadius: "20px" }} />

                <CustomDivider />
                <Typography variant='body1' mb={1} fontWeight={600}>
                    Description
                </Typography>
                <Typography variant='body2' >
                    {CourseDetail?.data?.description}
                </Typography>
                <CustomDivider size={"1rem"} />
                <Typography variant='body1' mb={1} fontWeight={600}>
                    Learning Outcome
                </Typography>
                <Typography variant='body2' >
                    {CourseDetail?.data?.learningoutcome}
                </Typography>
                <CustomDivider size={"1rem"} />
                <Typography variant='body2' >
                    {CourseDetail?.data?.short_description}
                </Typography>
                <CustomDivider />
                <CustomDivider size={"1rem"} />
                <Typography variant='body1' mb={1} fontWeight={600} sx={{ display: "flex", alignItems: "center" }}>
                    Grade Level : {CourseSlot?.orders?.order_details?.name}  (  <CurrencyRupeeIcon fontSize="20px" /> {CourseSlot?.orders?.order_details?.price})
                </Typography>
                <Typography variant='body2' >
                    {CourseSlot?.orders?.order_details?.description}
                </Typography>
                <CustomDivider />
                <Typography variant='body1' mb={1} fontWeight={600}>
                    Your Slots
                </Typography>
                <Typography variant='body2'>{`${CourseSlot?.orders?.start_date} - ${CourseSlot?.orders?.end_date}`}</Typography>
                {CourseSlot?.orders?.order_details?.submittedSlots?.map((item, index) => (
                    <SlotCard day={item?.day} timing={`${item?.start_time}-${item?.end_time}`} />
                ))

                }

            </Box>

            }
            {
                isLoading && isSlotLoading && <Box>
                    <SkeletonCom height={"300px"} />
                    <CustomDivider />
                    <TextSkeleton line={10} />
                </Box>
            }

            <Box px={8} my={5}>
                <CustomDivider orientation='horizontal' />
                <Typography variant="h5" mb={3}>Review & Rating</Typography>

                {isReviewsLoading ? (
                    <TextSkeleton line={3} />
                ) : (
                    <>
                        {reviewsData?.overallReview && (
                            <Box mb={4} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography variant="h2" color="red.main">
                                    {reviewsData.overallReview.averageRating}
                                </Typography>
                                <Box>
                                    <Rating
                                        value={Number(reviewsData.overallReview.averageRating)}
                                        readOnly
                                        precision={0.5}
                                        icon={<StarIcon sx={{ color: "red.main", fontSize: "25px" }} />}
                                        emptyIcon={<StarIcon sx={{ fontSize: "25px" }} />}
                                    />
                                    <Typography variant="body2" color="grey.400">
                                        Based on {reviewsData.overallReview.totalReviews} reviews
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        {reviewsData?.reviews?.length > 0 ? (
                            reviewsData.reviews.map((review, index) => (
                                <ReviewRatingCom key={review.id || index} review={review} />
                            ))
                        ) : (
                            <Typography variant="body1" color="grey.400">No reviews yet for this course.</Typography>
                        )}
                    </>
                )}
            </Box>
        </>

    )
}

export default StudentOnlineCourseDetail